export type OpenRouterBalanceView = {
  status: "ok" | "no_key" | "error";
  remainingUsd: number | null;
  usageUsd: number | null;
};

export function accountBalanceFromCredits(body: {
  data?: { total_credits?: number; total_usage?: number };
}): { remainingUsd: number; usageUsd: number } | null {
  const credits = body.data?.total_credits;
  const usage = body.data?.total_usage;
  if (typeof credits !== "number" || typeof usage !== "number") {
    return null;
  }
  return {
    remainingUsd: Math.round((credits - usage) * 100) / 100,
    usageUsd: usage,
  };
}

export function formatOpenRouterUsd(value: number): string {
  const sign = value < 0 ? "-" : "";
  return `${sign}$${Math.abs(value).toFixed(2)}`;
}

export function formatOpenRouterBalance(view: OpenRouterBalanceView): string {
  if (view.status === "no_key") {
    return "OpenRouter: нет ключа";
  }
  if (view.status === "error") {
    return "OpenRouter: нет данных";
  }
  if (view.remainingUsd != null) {
    return `OpenRouter ${formatOpenRouterUsd(view.remainingUsd)}`;
  }
  if (view.usageUsd != null) {
    return `OpenRouter расход ${formatOpenRouterUsd(view.usageUsd)}`;
  }
  return "OpenRouter: нет данных";
}

export function formatOpenRouterBalanceCompact(
  view: OpenRouterBalanceView,
): string {
  if (view.status === "ok" && view.remainingUsd != null) {
    return formatOpenRouterUsd(view.remainingUsd);
  }
  if (view.status === "ok" && view.usageUsd != null) {
    return formatOpenRouterUsd(view.usageUsd);
  }
  return "—";
}
